<template>
  <v-expansion-panel-content>
    <v-list class="pb-0">
      <v-list-item
        v-for="(faqQuestionReponse, indexQuestion) in questionsReponsesModifiable"
        :key="indexQuestion"
      >
        <v-list-item-content>
          <v-divider
            v-show="indexQuestion > 0"
            :key="indexQuestion"
          />
          <v-row>
            <v-col
              cols="auto"
              align-self="center"
            >
              <v-icon
                color="primary lighten-2"
                :disabled="disabledOnUp(faqQuestionReponse)"
                @click="onUp(indexQuestion)"
              >
                mdi-arrow-up-bold
              </v-icon>
            </v-col>
            <v-col
              cols="auto"
              align-self="center"
            >
              <v-icon
                color="primary lighten-2"
                :disabled="disabledOnDown(faqQuestionReponse)"
                @click="onDown(indexQuestion)"
              >
                mdi-arrow-down-bold
              </v-icon>
            </v-col>
            <v-col
              cols="auto"
              align-self="center"
            >
              <v-tooltip bottom>
                <template v-slot:activator="{ on, attrs }">
                  <v-icon
                    color="primary lighten-2"
                    v-bind="attrs"
                    v-on="on"
                  >
                    mdi-numeric-{{ faqQuestionReponse.ordre }}-circle
                  </v-icon>
                </template>
                <span>Ordre de tri de la question/réponse</span>
              </v-tooltip>
            </v-col>
            <v-col
              cols="auto"
              align-self="center"
            >
              <BaseData
                :value="faqQuestionReponse.intitule"
                label=""
                message="Aucune donnée"
                class="text-h6 mb-2 mb-md-0"
              />
            </v-col>
            <v-col
              cols="auto"
              class="align-end"
              align-self="center"
            >
              <v-tooltip top>
                <template v-slot:activator="{ on }">
                  <v-icon
                    class="mr-2"
                    color="secondary"
                    v-on="on"
                    @click="updateQuestionReponse(faqQuestionReponse)"
                  >
                    mdi-pencil
                  </v-icon>
                </template>
                Modifier
              </v-tooltip>
            </v-col>
            <v-col
              cols="auto"
              class="align-end"
              align-self="center"
            >
              <v-tooltip top>
                <template v-slot:activator="{ on }">
                  <v-icon
                    color="red"
                    v-on="on"
                    @click="deleteQuestionReponse(faqQuestionReponse)"
                  >
                    mdi-delete
                  </v-icon>
                </template>
                Supprimer
              </v-tooltip>
            </v-col>
          </v-row>
          <v-row class="mr-5">
            <v-col cols="6">
              <v-row>
                <v-col cols="1">
                  <v-icon size="50">
                    mdi-laptop
                  </v-icon>
                </v-col>
                <v-col cols="11">
                  <!-- eslint-disable -->
                  <div
                    class="container"
                    v-html="faqQuestionReponse.reponseOrdinateur"
                  />
                </v-col>
              </v-row>
            </v-col>
            <v-col cols="6">
              <v-row>
                <v-col cols="1">
                  <v-icon size="50">
                    mdi-cellphone-sound
                  </v-icon>
                </v-col>
                <v-col cols="11">
                  <!-- eslint-disable -->
                  <div
                    class="container"
                    v-html="faqQuestionReponse.reponseSmartphone"
                  />
                </v-col>
              </v-row>
            </v-col>
          </v-row>
        </v-list-item-content>
      </v-list-item>
    </v-list>
    <v-divider v-if="theme.questionsReponses.length > 0" />
    <v-row>
      <v-col>
        <v-tooltip top>
          <template v-slot:activator="{on}">
            <v-icon
              class="mr-2"
              color="secondary"
              large
              v-on="on"
              @click="addQuestionReponse()"
            >
              mdi-plus-circle
            </v-icon>
          </template>
          Créer une question/réponse
        </v-tooltip>
      </v-col>
    </v-row>
  </v-expansion-panel-content>
</template>

<script>
import BaseData from '@/components/common/base-data.vue'
import {clone} from '@/utils/clone'

export default {
  name: 'FaqQuestionsReponses',
  components: { BaseData },
  props: {
    theme: {
      type: Object,
      default: () => { }
    }
  },

  data () {
    return {
      dialogSaisie: false,
      dialogSupprimer: false,
      questionReponseModifie: {},
      questionsReponsesModifiable: [],
      questionReponseASupprimer: {}
    }
  },

  watch: {
    theme: {
      handler () {
        this.questionsReponsesModifiable = clone(this.theme.questionsReponses)
      },
      immediate: true
    }
  },

  methods: {
    addQuestionReponse () {
      this.questionReponseModifie.idTheme = this.theme.id
      this.$emit('addQuestionReponse', true, this.questionReponseModifie)
    },
    updateQuestionReponse (questionReponseModifie) {
      this.questionReponseModifie = clone(questionReponseModifie)
      this.$emit('updateQuestionReponse', true, this.questionReponseModifie)
    },
    deleteQuestionReponse (questionReponse) {
      this.questionReponseASupprimer = clone(questionReponse)
      this.$emit('deleteQuestionReponse', true, this.questionReponseASupprimer)
    },
    disabledOnUp (questionReponse) {
      return (questionReponse.ordre === 1 || this.questionsReponsesModifiable.length === 1)
    },
    disabledOnDown (questionReponse) {
      return (questionReponse.ordre === this.questionsReponsesModifiable.length || this.questionsReponsesModifiable.length === 1)
    },
    onUp (index) {
      if (index > 0) {
        this.questionsReponsesModifiable[index].ordre--
        this.$emit('saveQuestionReponseOrdre', this.questionsReponsesModifiable[index])
        this.questionsReponsesModifiable[index - 1].ordre++
        this.$emit('saveQuestionReponseOrdre', this.questionsReponsesModifiable[index - 1])
      }
    },
    onDown (index) {
      this.questionsReponsesModifiable[index].ordre++
      this.$emit('saveQuestionReponseOrdre', this.questionsReponsesModifiable[index])
      this.questionsReponsesModifiable[index + 1].ordre--
      this.$emit('saveQuestionReponseOrdre', this.questionsReponsesModifiable[index + 1])
    }
  }
}
</script>

<style lang="scss" scoped>
.align-end {
  text-align: end;
}

.icon {
  text-align: end;
}

.font-reponse {
  font-size: 17px;
  color: black;
}

.container {
  border: 1px solid #3f3434;
  border-radius: 30px;
}
</style>
